import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";
import rootReducer from "./store/reducers";
import { Auth } from "./Components/Auth/Auth";
import { BrowserRouter as Router, useNavigate } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import {
  successfulLoginRedirectUrl,
  authzClientId,
  authzDomain,
  authzAudience,
} from "./auth/auth0";
import { initSentry } from "./sentry";
import posthog from 'posthog-js';

const store = createStore(rootReducer, applyMiddleware(thunk));
if (import.meta.env.MODE !== "development") {
  initSentry();
}

posthog.init("phc_DzATNluXUi5XpCnJ6QmzE9IT1pslYH2bbKfEkGhpQhi", {
  api_host: "https://us.i.posthog.com",
});



// Custom Auth0ProviderWrapper to use React Router's navigation
const Auth0ProviderWrapper = ({ children }: { children: any }) => {
  const navigate = useNavigate();

  const onRedirectCallback = (appState: any) => {
    const targetUrl = "/team-selection";
    console.log("appstate", appState)
    const query = appState?.returnTo ? `?returnTo=${appState.returnTo}` : "";
    navigate(targetUrl + query);
  };

  return (
    <Auth0Provider
      domain={authzDomain}
      clientId={authzClientId}
      authorizationParams={{
        audience: authzAudience,
        redirect_uri: successfulLoginRedirectUrl,
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};

// Root component with Provider, Router, and Auth0 integration
const Root = () => (
  <Provider store={store}>
    <Router>
      <Auth0ProviderWrapper>
        <Auth>
          <App />
        </Auth>
      </Auth0ProviderWrapper>
    </Router>
  </Provider>
);

(ReactDOM as any).render(<Root />, document.getElementById("root"));